import React from 'react';
import { Container, Box } from '@mui/material';
import Chat from './Chat';
import Footer from '../Footer/Footer';

const Home = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        //minHeight: '90vh',
        width: '100%',
        gap: 1,
      }}
    >
      {/* Main content area */}
      <Container
        maxWidth={false}
        sx={{ 
          flexGrow: 0,
          py: 0,
          px: { xs: 0 },
          textAlign: 'center',
          position: 'relative',
          width: '100%',
        }}
      >
        <Chat />
      </Container>
      
      <Footer />
    </Box>
  );
};

export default Home;